/**
 * Domain enums. These mirror the Prisma enums 1:1 and are the single source of
 * truth for both clients. Declared as const objects + union types so they work
 * identically in the backend (Prisma), the web bundle and React Native.
 */

export const Platform = {
  CODEFORCES: 'CODEFORCES',
  ATCODER: 'ATCODER',
  LEETCODE: 'LEETCODE',
  OTHER: 'OTHER',
} as const;
export type Platform = (typeof Platform)[keyof typeof Platform];
export const PLATFORMS = Object.values(Platform);

export const NormalizedDifficulty = {
  EASY: 'EASY',
  MEDIUM: 'MEDIUM',
  HARD: 'HARD',
  EXPERT: 'EXPERT',
} as const;
export type NormalizedDifficulty = (typeof NormalizedDifficulty)[keyof typeof NormalizedDifficulty];
export const NORMALIZED_DIFFICULTIES = Object.values(NormalizedDifficulty);

export const TopicStatus = {
  NOT_STARTED: 'NOT_STARTED',
  LEARNING: 'LEARNING',
  PRACTICING: 'PRACTICING',
  MASTERED: 'MASTERED',
} as const;
export type TopicStatus = (typeof TopicStatus)[keyof typeof TopicStatus];
export const TOPIC_STATUSES = Object.values(TopicStatus);

/** Ordinal rank used for "has at least reached" comparisons. */
export const TOPIC_STATUS_RANK: Record<TopicStatus, number> = {
  NOT_STARTED: 0,
  LEARNING: 1,
  PRACTICING: 2,
  MASTERED: 3,
};

export const TopicCategory = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  EXPERT: 'EXPERT',
} as const;
export type TopicCategory = (typeof TopicCategory)[keyof typeof TopicCategory];
export const TOPIC_CATEGORIES = Object.values(TopicCategory);

export const SessionKind = {
  SOLVING: 'SOLVING',
  STUDYING: 'STUDYING',
  REVIEW: 'REVIEW',
} as const;
export type SessionKind = (typeof SessionKind)[keyof typeof SessionKind];
export const SESSION_KINDS = Object.values(SessionKind);

export const RatingTier = {
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM',
  ALGORITHM_MASTER: 'ALGORITHM_MASTER',
} as const;
export type RatingTier = (typeof RatingTier)[keyof typeof RatingTier];
export const RATING_TIERS = Object.values(RatingTier);

export const SnapshotKind = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const;
export type SnapshotKind = (typeof SnapshotKind)[keyof typeof SnapshotKind];
